export default __webpack_public_path__ + "static/wallet-as-a-service-d4281978a9fcb81ea06c3f9e99a6edbd.png";